import { ProductId, ProductOfferingId } from "app/shared/model/EditProductOffering";

const toTitleCase = (value:string) => {
    if (!value) return value;

    //If there is dash, take only the part before it
    const dashIndex = value.indexOf("-");
    if (dashIndex !== -1) {
        value = value.substring(0, dashIndex);
    }

    //Add Spaces
    value = value.replace(/([a-z])([A-Z])/g, '$1 $2');
    value = value.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
    

    //from camelCase to TitleCase
    value = value.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLocaleLowerCase() + ' ');

    return value.trim();
}

const generateProductCode = (productId: ProductId) => {
    return `${productId.type.name}-${productId.id}`;
}

const stringHelper = {toTitleCase, generateProductCode};

export default stringHelper;